import { CHART_OF_ACCOUNT_SUCCESS } from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case CHART_OF_ACCOUNT_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}